import React from 'react';
import { Link } from 'react-router-dom';
import './EventsSection.css';

const EventsSection = () => {
  return (
    <section className="events-section fade-in" id="evenements">
      <div className="events-beige-band">
        <div className="events-container">
          <h2 className="heading-art-deco events-title">
            THE RECAP, les prochaines éditions :
          </h2>
          <div className="events-grid">
            {/* Le Live Card */}
            <div className="event-card slide-up" style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${process.env.PUBLIC_URL}/images/hero-bg.png)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="event-card-inner">
                <div className="event-card-names">
                  <span className="event-card-name">Laetitia Lamari</span>
                  <span className="event-card-name">Adrien Naeem</span>
                </div>
                <div className="event-card-logo">
                  <img src="/images/logo-blanc.png" alt="THE RECAP" className="card-logo" />
                </div>
                <div className="event-card-profiles">
                  <img src="/images/laetitia.png" alt="Laetitia" className="profile-photo" />
                  <img src="/images/adrien.png" alt="Adrien" className="profile-photo" />
                </div>
                <h3 className="event-card-title">LE LIVE</h3>
                <p className="event-card-subtitle">NRF Asia Pacific</p>
                <p className="event-card-info">4 JUIN 2026 | 🔴 | LIVE LINKEDIN</p>
              </div>
            </div>

            {/* Le Dîner Card */}
            <div className="event-card slide-up" style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${process.env.PUBLIC_URL}/images/hero-bg.png)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="event-card-inner">
                <div className="event-card-names">
                  <span className="event-card-name">Laetitia Lamari</span>
                  <span className="event-card-name">Adrien Naeem</span>
                </div>
                <div className="event-card-logo">
                  <img src="/images/logo-blanc.png" alt="THE RECAP" className="card-logo" />
                </div>
                <div className="event-card-profiles">
                  <img src="/images/laetitia.png" alt="Laetitia" className="profile-photo" />
                  <img src="/images/adrien.png" alt="Adrien" className="profile-photo" />
                </div>
                <h3 className="event-card-title">LE DÎNER</h3>
                <p className="event-card-subtitle">NRF Asia Pacific</p>
                <p className="event-card-info">11 JUIN 2026 | PARIS</p>
              </div>
            </div>
          </div>

          <div className="events-details">
            <div className="event-detail-card slide-up">
              <h4 className="detail-title">Le Live</h4>
              <p className="detail-subtitle">Spécial NRF APAC</p>
              <p className="detail-info">Le 4 juin | Live LinkedIn</p>
              <Link to="/inscription" className="button button-dark">Je m'inscris</Link>
            </div>

            <div className="event-detail-card slide-up">
              <h4 className="detail-title">Le Dîner</h4>
              <p className="detail-subtitle">Spécial NRF APAC</p>
              <p className="detail-info">Le 11 juin | Paris</p>
              <Link to="/inscription" className="button button-dark">Je m'inscris</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
